<template lang="pug">
  footer.site-footer
    .container
      .row.align-items-center
        .col
          router-link.d-inline-block.site-footer__logo(to="/")
            img(src="/img/frontend/logo/logo.svg", alt='')
          a.d-inline-block.site-footer__logo.site-footer__logo--spark.ml-4(href="https://www.spabattery.com/" target="_blank")
            img(src="/img/frontend/logo/spa-logo.png", alt='')
      .row
        .col-lg-3.col-md-4
          .site-footer__company-info
            elementor(object-type="template" object-slug="footer-address")
        .col-6.col-lg-2.col-md-2
          .site-footer__navigation
            h6.site-footer__navigation-title {{ trans('labels.frontend.footer.products') }}
            ul.list-unstyled.site-footer__navigation-list
              li.site-footer__navigation-list-item(v-for="item in main_menu_items" :key="item.id")
                router-link(:to='item.url' :title='item.name') {{ item.name }}
        .col-6.col-lg-2.col-md-3
          .site-footer__navigation
            h6.site-footer__navigation-title {{ trans('labels.frontend.footer.menu') }}
            ul.list-unstyled.site-footer__navigation-list
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'account.payment-notify', params: { slug: 'how-to-order' } }")
                  | {{ trans('menus.frontend.navigation.payment-notify') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'blog.index' }")
                  | {{ trans('menus.frontend.navigation.articles') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'page', params: { slug: 'about-us' } }")
                  | {{ trans('menus.frontend.navigation.about-us') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'jobs' }" :title="trans('menus.frontend.navigation.join-us')")
                  | {{ trans('menus.frontend.navigation.join-us') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'distributors' }" :title="trans('menus.frontend.navigation.distributors')")
                  | {{ trans('menus.frontend.navigation.distributors') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'contact' }" :title="trans('menus.frontend.navigation.contact-us')")
                  | {{ trans('menus.frontend.navigation.contact-us') }}
        .col-6.col-lg-2.col-md-3
          .site-footer__navigation
            h6.site-footer__navigation-title {{ trans('labels.frontend.footer.help') }}
            ul.list-unstyled.site-footer__navigation-list
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'help.single', params: { slug: 'how-to-order' } }")
                  | {{ trans('menus.frontend.navigation.how-to-buy') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'help.single', params: { slug: 'tracking' } }")
                  | {{ trans('menus.frontend.navigation.check-tracking') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'help.single', params: { slug: 'faqs' } }")
                  | {{ trans('menus.frontend.navigation.faqs') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'help.single', params: { slug: 'shipping' } }")
                  | {{ trans('menus.frontend.navigation.how-to-ship') }}
              li.site-footer__navigation-list-item
                router-link(:to="{ name: 'help.single', params: { slug: 'how-to-claim' } }")
                  | {{ trans('menus.frontend.navigation.how-to-claim') }}
        .col-lg-3
          .row
            .col-md-6.col-lg-12
              .site-footer__payment-methods
                h6.site-footer__payment-method-title {{ trans('labels.frontend.footer.payment-methods') }}
                elementor(object-type="template" object-slug="footer-payment")
            .col-md-6.col-lg-12
              .site-footer__shipping-methods
                h6.site-footer__shipping-method-title {{ trans('labels.frontend.footer.shipping') }}
                elementor(object-type="template" object-slug="footer-shipping")
      .row.align-items-center.mt-5.text-center.text-lg-left
        .col-lg-6
          p.site-footer__copyright-text &copy; 2020 SPARK INTERTRADE. All Rights Reserved.
        .col-lg-6.text-center.text-lg-right
          .site-footer__socials
            span.site-footer__social-title
              | Follow us
            a.site-footer__social-icon.site-footer__social-icon--facebook(href='https://www.facebook.com/spabattery/' target="_blank" @click="onFacebookClicked")
              font-awesome-icon(:icon=['fab', 'facebook-square'])
            a.site-footer__social-icon.site-footer__social-icon--line(href='https://line.me/ti/p/~@spabattery' target="_blank" @click="onLineClicked")
              font-awesome-icon(:icon=['fab', 'line'])
</template>

<script>
import { RepositoryFactory } from '../../repositoryFactory';
import ConversionManager from '../../mixins/ConversionManager';

const MenuRepository = RepositoryFactory.get('menu');

export default {
  mixins: [ConversionManager],
  data() {
    return {
      main_menu_items: [],
    };
  },
  created() {
    this.getMenu();
  },
  methods: {
    async getMenu() {
      const { data } = await MenuRepository.get('footer-menu', { lang: this.$store.getters['auth/user'].locale || 'th' }).then((resp) => resp.data);
      this.main_menu_items = data.items[0] ?? [];
    },
    onLineClicked() {
      this.trackEvent('Click', 'Buttons', 'Add Line', 'Add Line (Footer)', 1);
    },
    onFacebookClicked() {
      this.trackEvent('Click', 'Buttons', 'Visit Facebook', 'Visit Facebook (Footer)', 1);
    },
  },
};
</script>
